import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ComparisonTable() {
  const rows = [{
    sit: 'No sabés qué hacer cada día',
    sin: 'Dudás',
    con: 'Tenés claridad total'
  }, {
    sit: 'Falta de constancia',
    sin: 'Abandonás',
    con: 'Seguís paso a paso'
  }, {
    sit: 'Poco tiempo',
    sin: 'No hacés nada',
    con: 'Tenés versión adaptada'
  }, {
    sit: 'Confusión',
    sin: 'Pensás demasiado',
    con: 'Ejecutás directo'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-40">
      <div className="text-center mb-12" data-id="element-41">
        <h2 className="font-display text-2xl md:text-4xl font-bold flex items-center justify-center gap-3 text-gray-900" data-id="element-42">
          <span data-id="element-43">💡</span> ¿QUÉ CAMBIA CON EL PLAN PERSONALIZADO?
        </h2>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="overflow-x-auto" data-id="element-44">
        <div className="min-w-[600px] bg-brand-card border border-pink-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-45">
          <div className="grid grid-cols-3 bg-pink-50/80 border-b border-pink-200 p-4 font-bold text-sm md:text-base" data-id="element-46">
            <div className="text-gray-500" data-id="element-47">Situación</div>
            <div className="text-gray-500 text-center" data-id="element-48">Sin Plan</div>
            <div className="text-brand-accent text-center" data-id="element-49">Con Plan</div>
          </div>

          <div className="divide-y divide-pink-200/50" data-id="element-50">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-3 p-4 items-center text-sm md:text-base hover:bg-pink-50 transition-colors" data-id="element-51">
                <div className="text-gray-600 font-medium pr-4" data-id="element-52">{row.sit}</div>
                <div className="text-gray-400 text-center flex flex-col items-center gap-1" data-id="element-53">
                  <X size={16} className="text-brand-danger/50" data-id="element-54" />
                  <span data-id="element-55">{row.sin}</span>
                </div>
                <div className="text-gray-900 font-bold text-center flex flex-col items-center gap-1 bg-pink-100 py-2 rounded-lg" data-id="element-56">
                  <Check size={16} className="text-brand-accent" data-id="element-57" />
                  <span data-id="element-58">{row.con}</span>
                </div>
              </div>)}
          </div>
        </div>
      </motion.div>

      <div className="text-center mt-12 space-y-2 text-xl md:text-2xl font-medium text-gray-600" data-id="element-59">
        <p data-id="element-60">👉 Es la diferencia entre intentar…</p>
        <p className="font-bold text-gray-900" data-id="element-61">👉 y lograrlo.</p>
      </div>
    </section>;
}